import { cx } from '@linaria/core';
import { useRef, useEffect } from 'react';
import { PM2LightBulbIcon } from '@ui/kit/icons';
import { scrollTo } from '@utils/common';
import { easeOut } from '@utils/constants';
import { useIntersectionObserver, CSSRefTransition } from '@utils/react';
import { revealTransitionDurationMs, hint, badge, label, text } from './atom.hint.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

let isScrolling = false;
function Hint(props) {
  const ref = useRef(null);
  const isIntersecting = useIntersectionObserver(ref, {
    once: true
  });
  useScrollIntoViewOnMount(ref);
  const isVisible = isIntersecting || !props.withAnimation;
  return /*#__PURE__*/jsx(CSSRefTransition, {
    in: isVisible,
    nodeRef: ref,
    classNames: hint,
    timeout: {
      enter: revealTransitionDurationMs,
      exit: 0
    },
    children: ref => /*#__PURE__*/jsxs("div", {
      ref: ref,
      className: cx(hint, isVisible && "visible"),
      "data-highlighted": props.highlighted,
      children: [/*#__PURE__*/jsx("div", {
        className: badge,
        children: /*#__PURE__*/jsx(PM2LightBulbIcon, {
          height: 22
        })
      }), /*#__PURE__*/jsxs("span", {
        className: label,
        children: ["Hint ", props.index + 1, ":"]
      }), /*#__PURE__*/jsx("span", {
        className: text,
        children: props.text
      })]
    })
  });
}
function useScrollIntoViewOnMount(ref) {
  useEffect(() => {
    const isEntering = ref.current?.parentElement?.className.includes("-enter");
    if (isEntering && !isScrolling) {
      const boundingBox = ref.current?.getBoundingClientRect();
      if (!boundingBox) {
        return;
      }

      // Don't bother scrolling if the top of the embed target is clearly
      // within view. NB: We do not bother checking lower bounds as the
      // component cannot be navigated when outside of the viewport as it
      // will be inactive in this state.
      if (boundingBox.top > 150) {
        return;
      }
      isScrolling = true;
      scrollTo(boundingBox.top + window.scrollY - 200, {
        minDurationMs: 200,
        maxDurationMs: 375,
        easingFn: p => easeOut(p, 3)
      });
      setTimeout(() => {
        isScrolling = false;
      }, 375);
    }
  }, [ref]);
}

export { Hint };
//# sourceMappingURL=atom.hint.js.map
